import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from '../config/firebase';

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Track page view on every location change
        logEvent('page_view', {
            page_path: location.pathname,
            page_search: location.search,
            page_title: document.title
        });
    }, [location]);

    return null;
};

export default AnalyticsTracker;
